<script setup lang="ts">
import { ref } from 'vue'

/** 普通弹框配置 */
interface CouponPopupObj {
  /** 主键ID */
  configId?: string
  /** 背景图片 */
  imgUrl?: string
  /** 跳转链接 */
  jumpUrl?: string
}

interface CouponPopup {
  popupData?: CouponPopupObj
  /** ads标题 */
  adsTitle?: string
}
const { popupData, adsTitle } = defineProps<CouponPopup>()
const emits = defineEmits(['clickPopup', 'closePopup'])
/** 弹框显示隐藏 */
const showDialog = ref(true)
/** 关闭弹框 */
function closeDialog() {
  showDialog.value = false
  emits('closePopup')
}
/** 跳转url */
function handleJump() {
  showDialog.value = false
  emits('clickPopup', popupData?.jumpUrl)
}
</script>

<template>
  <div v-if="showDialog">
    <div class="layer touch-none" @touchmove.prevent />
    <div
      v-if="popupData && popupData.imgUrl"
      class="coupons touch-none"
    >
      <div
        class="pop"
        @click="handleJump"
      >
        <img :src="popupData?.imgUrl">
      </div>
      <div class="close touch-none" @click="closeDialog">
        <img src="https://file.reshg.com/hopegoo/adsPopup/close.png" alt="">
      </div>
      <div class="img-ads">
        {{ adsTitle || 'Ads' }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.layer {
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0, 0, 0, 0.7);
 z-index: 100;
}

.coupons {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-height: 100px;
  z-index: 101;
  border-radius: 16px;
  border-radius: 8px;
  .pop {
    overflow-y: scroll;
    overscroll-behavior: none;
    width: 100%;
    & > img {
      width: 100%;
    }
  }
  .close {
    position: absolute;
    bottom: -40px;
    height: 28px;
    width: 28px;
    left: 50%;
    margin-left: -14px;
    z-index: 101;
  }
  .img-ads {
    position: absolute;
    bottom: calc(100% + 4px);
    color: #ffffff;
    font-size: 10px;
    right: 16px;
    z-index: 101;
  }
}
.touch-none {
 touch-action: none;
}
</style>
